import React from "react";
import HeaderUser from "./HeaderUser";
import Logo from "../../assets/images/logo.png";
const index = () => {
  return (
    <>
    <div className="w-[100%] h-[60px] bg-white px-[24px] py-[10px] border border-solid border-bottom border-[#E9E9E9] md:flex hidden items-center justify-between">
      <div>
        <h3>Merhaba Tarık 👋</h3>
      </div>
      <HeaderUser />
    </div>
    <div className="w-[100%] h-[60px] bg-white px-[10px] py-[10px] border border-solid border-bottom border-[#E9E9E9] flex items-center justify-between md:hidden">
     <img src={Logo} alt=""/>
     <h3 className="text-[14px] font-semibold">Hoşgeldin, Tarık 👋</h3>
    </div>
    </>
    
  );
};

export default index;
